import { PageLink } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'

export const StartupDocBreadCrum: Array<PageLink> = [
    {
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
    {
        title: 'Co-Founder Connect',
        path: '/cofounder-connect',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]


export const CoFounderConnectBreadCrum: Array<PageLink> = [
    {
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

export const CoFounderConnectBreadcrum = () => {
    const { formatMessage } = useIntl()

    const StartupDocBreadCrum: Array<PageLink> = [
        {
            title: formatMessage({ id: 'Home' }),
            path: '/',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: formatMessage({ id: 'Co-Founder Connect' }),
            path: '/cofounder-connect',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]

    const CoFounderConnectBreadCrum: Array<PageLink> = [
        {
            title: formatMessage({ id: 'Home' }),
            path: '/',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]
    return {
        StartupDocBreadCrum,
        CoFounderConnectBreadCrum,
    }
}